import React, { useState } from "react";
import { Menu, Home, Calendar as CalendarIcon } from "lucide-react";
import Sidebar from "../components/Calendar/Sidebar";
import Dashboard from "../components/Calendar/Dashboard";
import CalendarView from "../components/Calendar/CalendarView";
import MainHeader from "../MainHeader";

/**
 * 메인 캘린더 앱 컴포넌트
 */
export default function CalendarApp() {
  const [currentView, setCurrentView] = useState("dashboard");
  const [selectedCalendars, setSelectedCalendars] = useState([]);
  const [showSidebar, setShowSidebar] = useState(true);
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  const handleCalendarSelect = (calendarIds) => {
    setSelectedCalendars(calendarIds);
    // 초기 로드가 완료되면 플래그 해제
    if (isInitialLoad && calendarIds.length > 0) {
      setIsInitialLoad(false);
    }
  };

  return (
    <>
      <MainHeader />
      <div className="h-screen flex bg-gray-50">
        {/* 사이드바 */}
        {showSidebar && (
          <Sidebar
            selectedCalendars={selectedCalendars}
            onCalendarSelect={handleCalendarSelect}
          />
        )}

        {/* 메인 콘텐츠 */}
        <div className="flex-1 flex flex-col">
          {/* 상단 네비게이션 */}
          <div className="bg-white border-b px-4 py-3">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-4">
                <button
                  onClick={() => setShowSidebar(!showSidebar)}
                  className="p-2 hover:bg-gray-100 rounded-lg"
                >
                  <Menu className="w-5 h-5" />
                </button>
                <div className="flex space-x-2">
                  <button
                    onClick={() => setCurrentView("dashboard")}
                    className={`flex items-center px-3 py-2 rounded-lg transition-colors ${
                      currentView === "dashboard"
                        ? "bg-blue-50 text-blue-600"
                        : "hover:bg-gray-100"
                    }`}
                  >
                    <Home className="w-4 h-4 mr-2" />
                    대시보드
                  </button>
                  <button
                    onClick={() => setCurrentView("calendar")}
                    className={`flex items-center px-3 py-2 rounded-lg transition-colors ${
                      currentView === "calendar"
                        ? "bg-blue-50 text-blue-600"
                        : "hover:bg-gray-100"
                    }`}
                  >
                    <CalendarIcon className="w-4 h-4 mr-2" />
                    캘린더
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* 콘텐츠 영역 */}
          <div className="flex-1 overflow-auto">
            {currentView === "dashboard" ? (
              <Dashboard />
            ) : (
              <CalendarView selectedCalendars={selectedCalendars} />
            )}
          </div>
        </div>
      </div>
    </>
  );
}
